import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { WorkflowSteps } from 'components/global/atoms'
import Step from './Step'

function onSelected(value, fields) {
  const values = fields.getAll()
  const isSelected = values && !!values.find((v) => v.approver === value)

  if (isSelected) return true

  return fields.push({
    approver: value,
    step_count: fields.length + 1,
  })
}

const WorkflowStepsField = ({ fields, workflow_steps, change }) => (
  <div>
    <WorkflowSteps
      onSelected={(value) => onSelected(value, fields)}
      // hideCreate={fields.getAll().length >= 6} avoiding crash app in create
    >
      {fields.map((step, index) => {
        change(`${step}.step_count`, index + 1)
        return (
          <Field
            key={`WorkflowSteps-${index}`}
            name={`${step}.approver`}
            component={Step}
            stepNo={index + 1}
            onRemove={() => fields.remove(index)}
            workflow_step={
              workflow_steps && workflow_steps[index] ? [workflow_steps[index].approver] : []
            }
          />
        )
      })}
    </WorkflowSteps>
  </div>
)

WorkflowStepsField.propTypes = {
  fields: PropTypes.shape(),
  workflow_steps: PropTypes.arrayOf(Object),
  change: PropTypes.func,
}

export default WorkflowStepsField
